/**
 * change state of selected Test Series
 * @param testSeriesId
 */
export const setTestSeries = (testSeriesId) => dispatch => {
    dispatch({
        type: 'CURRENT_TEST_SERIES',
        payload: testSeriesId
    });
};